import { Container } from '../../../odie';

import { config } from '../../../game/defs/config';
import { arrayCreate2 } from '../../../lib/util/jsTools';

// types
//-----------------------------------------------------------------------------
type Cell = {
  view?: Container;
};

/*
    editor grid layer
*/
export class EditorGridLayer extends Container {
  // fields
  //-------------------------------------------------------------------------
  // state
  private readonly _cells: Cell[][];

  // properties
  //-------------------------------------------------------------------------
  public get cells(): Cell[][] {
    return this._cells;
  }

  // init
  //-------------------------------------------------------------------------
  constructor() {
    super();

    // auto z sort
    this.sortableChildren = true;

    // initialize grid
    this._cells = arrayCreate2<Cell>(
      config.map.columns,
      config.map.rows,
      () => ({}),
    );
  }

  // api
  //-------------------------------------------------------------------------
  public setCell(column: number, row: number, view?: Container) {
    // despawn existing view at this cell
    this._despawnCell(column, row);

    // spawn if specified view
    if (view) {
      this._spawnCell(column, row, view);
    }
  }

  public getCell(column: number, row: number) {
    return this._cells[column][row];
  }

  // private: support
  //-------------------------------------------------------------------------
  private _despawnCell(column: number, row: number) {
    // get cell
    const cell = this._cells[column][row];

    // if exists, despawn
    if (cell.view) {
      this.removeChild(cell.view);
    }
  }

  private _spawnCell(column: number, row: number, view: Container) {
    // get cell
    const cell = this._cells[column][row];

    // position view
    view.x += column * config.tile.size;
    view.y += row * config.tile.size;
    view.zIndex = -view.y;

    // add view to cell
    cell.view = view;

    // spawn view
    this.addChild(view);
  }
}
